import React, { Component } from 'react';
import { Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';

class AlertMessage extends Component {
  render() {
    const {
      text,
      classAlert,
      buttonUndo,
      linkCancel,
      linkRetry,
      spinner,
      toggle,
    } = this.props;

    return (
      <div className={'a-message ' + classAlert}>
        <div className="a-message__inner">
          {spinner && (
            <div className="a-message__spinner">
              <div className="b-spinner">
                <div className="b-spinner__loader" />
              </div>
            </div>
          )}
          <div className="a-message__text">{text}</div>
          {(buttonUndo || linkRetry || linkCancel) && (
            <div className="a-message__btn">
              {buttonUndo && (
                <button className="alert-link transparent m-l-15">
                  {buttonUndo}
                </button>
              )}
              {linkRetry && (
                <a href="#" className="alert-link">
                  {linkRetry}
                </a>
              )}
              {linkCancel && (
                <span onClick={toggle} className="std-text white pointer">
                  {linkCancel}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AlertMessage;



// WEBPACK FOOTER //
// ./src/components/AlertMessage/AlertMessage.js